// src/components/Support.js
import React, { useState, useRef } from 'react';

const Support = () => {
    const [openQuestion, setOpenQuestion] = useState(null);
    const [isTyping, setIsTyping] = useState(false);
    const [isSent, setIsSent] = useState(false);
    const formRef = useRef(null);
    const typingTimeoutRef = useRef(null);

    const handleQuestionClick = (questionIndex) => {
        setOpenQuestion(openQuestion === questionIndex ? null : questionIndex);
    };

    const handleMessageInput = () => {
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }
        setIsTyping(true);
        typingTimeoutRef.current = setTimeout(() => {
            setIsTyping(false);
        }, 1000);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSent(true);

        // Сброс формы через 2 секунды после анимации
        setTimeout(() => {
            setIsSent(false);
            if (formRef.current) {
                formRef.current.reset();
            }
        }, 2000);
    };

    // Примеры FAQ с подробными ответами
    const FAQs = [
        {
            question: "How do I reset my access to the app?",
            answer: "To reset your access:\n Contact support and provide as much details about your account as you can, so the collegues acna resolve the problem faster."
        },
        {
            question: "How does the AI outfit suggestion work?",
            answer: "Our AI outfit suggestion system works through several steps:\n1. Analyzes your style preferences and previous choices\n2. Checks current weather conditions in your location\n3. Considers the occasion or event type\n4. Matches items from our curated collection\n\nThe AI continuously learns from user feedback to improve its suggestions."
        },
        {
            question: "Can I change my style preferences?",
            answer: "Yes, you can update your style preferences at any time:\n1. Go to your Profile settings\n2. Click on 'Style Preferences'\n3. Update your choices for:\n   • Style type\n   • Color preferences\n   • Occasion preferences\n4. Save your changes\n\nChanges will be reflected in your next outfit suggestions."
        },
        {
            question: "I don't recieve outfit via my email",
            answer: "For a solution we recommend check the 'spam' folder and also unmark the letter as spam, so you will recieve the outfit normally."
        },
        {
            question: "Can I change language of the system?",
            answer: "For now - No, but as you can see in 'Profile' page there's that block in settings, so we're wotking on adding it in the app soon."
        }
    ];

    return (
        <div className="support-container">
            <div className="support-header">
                <h1 className="support-title">How can we help you?</h1>
                <p className="support-subtitle">Find answers or contact our support team</p>
            </div>

            <div className="support-content">
                <div className="faq-section">
                    <h2>Frequently Asked Questions</h2>
                    {FAQs.map((faq, index) => (
                        <div 
                            key={index}
                            className={`faq-item ${openQuestion === index ? 'open' : ''}`}
                            onClick={() => handleQuestionClick(index)}
                        >
                            <p className="faq-question">{faq.question}</p>
                            <div className="faq-answer">
                                {faq.answer.split('\n').map((line, i) => (
                                    <p key={i}>{line}</p>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="contact-description-section">
                        <h2>Get in Touch</h2>
                        <p>
                            Having trouble or need more information? Our support team is here 
                            to help you with any questions or concerns you might have about 
                            our services.
                        </p>
                        <ul>
                            <li>
                                <i className="fas fa-envelope"></i>
                                Email: support@styleforecast.com
                            </li>
                            <li>
                                <i className="fas fa-clock"></i>
                                Response Time: Within 24 hours
                            </li>
                            <li>
                                <i className="fas fa-calendar"></i>
                                Working Hours: Mon-Fri, 9:00 AM - 6:00 PM
                            </li>
                        </ul>
                </div>

                <div className="contact-container">
                    <div className="contact-form-section">
                        <div className="phone-mockup">
                            <div className="volume-buttons"></div>
                            <div className="power-button"></div>
                            <div className="screen">
                                <div className={`typing-indicator ${isTyping ? 'visible' : ''}`}>
                                    <span className="typing-dot"></span>
                                    <span className="typing-dot"></span>
                                    <span className="typing-dot"></span>
                                </div>
                                
                                <form ref={formRef} className="contact-form" onSubmit={handleSubmit}>
                                    <label htmlFor="contact-email">Email:</label>
                                    <input 
                                        type="email" 
                                        id="contact-email" 
                                        name="contact-email" 
                                        placeholder="Enter your email" 
                                        required 
                                    />
                                    
                                    <label htmlFor="contact-message">Message:</label>
                                    <textarea 
                                        id="contact-message" 
                                        name="contact-message" 
                                        placeholder="Enter your message" 
                                        required
                                        onInput={handleMessageInput}
                                    ></textarea>
                                    
                                    <button 
                                        type="submit" 
                                        className={`send-button ${isSent ? 'sent' : ''}`}
                                    >
                                        <span>Send Message</span>
                                        <i className="fas fa-paper-plane"></i>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Support;